import { useCallback } from 'react';
import { useGlobalModalContext } from './GlobalModalContext.esm.js';

/**
 * The `useModal` hook takes a Modal Component, and returns an `openModal` and a `closeModal` function.
 * A Modal component is a component that has an `isOpen`, a `closeModal` and any other props.
 * When calling `isOpen`, pass the props that should be sent to the Modal Component.  Don't send `isOpen` or `closeModal`, those will be provided for you.
 * @param RenderModal
 */
function useModal(RenderModal) {
    const { dispatch } = useGlobalModalContext();
    const openModal = useCallback((props) => {
        dispatch({ payload: { RenderModal, props }, type: "openModal" });
    }, [RenderModal]);
    const closeModal = useCallback(() => {
        dispatch({ payload: { RenderModal }, type: "closeModal" });
    }, [RenderModal]);
    return {
        closeModal: closeModal,
        openModal: openModal,
    };
}

export { useModal };
//# sourceMappingURL=useModal.esm.js.map
